import _ from "lodash";

const initialState = {
  total: "",
  data: [],
  report: "",
  report_title: "",
  report_version: "",
  result_id: -1,
  report_form_id: "",
  report_icon_path: "",
  report_date_added: ""
};

const sentItems = (state = initialState, action) => {
  switch (action.type) {
    case "RECEIVE_SENT_ITEMS":
      return Object.assign({}, state, {
        data: action.sentItems,
        total: action.total
      });
    case "RESET_SENT_ITEMS":
      return Object.assign({}, state, {
        data: [],
        total: "",
        report: "",
        report_title: "",
        report_version: "",
        result_id: -1,
        report_form_id: "",
        report_icon_path: "",
        report_date_added: ""
      });
    case "UPDATE_REPORT":
      return Object.assign({}, state, {
        report: action.report,
        report_icon_path: action.icon_path,
        report_title: action.form_title,
        report_version: action.form_version,
        result_id: action.result_id,
        report_date_added: action.date_added,
        report_form_id: action.form_id
      });
    default:
      return state;
  }
};

export default sentItems;



// WEBPACK FOOTER //
// ./src/reducers/sentItems.js